/** Patient surface shell (P-01..P-19). Responsive: sidebar on desktop, bottom nav on mobile. */

import { EmergencyButton } from "../../components/EmergencyButton";
import {
  AlarmIcon,
  BagIcon,
  BellIcon,
  GearIcon,
  LifebuoyIcon,
  PinIcon,
  RoleLayout,
  RxIcon,
  SosIcon,
  UploadIcon,
  UserIcon,
  UsersIcon,
} from "../../components/RoleLayout";

export function PatientLayout() {
  return (
    <RoleLayout
      title="My Health"
      actions={<EmergencyButton />}
      nav={[
        { to: "/patient/prescriptions", label: "Prescriptions", short: "Rx", icon: <RxIcon /> },
        { to: "/patient/orders", label: "Orders", short: "Orders", icon: <BagIcon /> },
        { to: "/patient/reminders", label: "Reminders", short: "Remind", icon: <AlarmIcon /> },
        { to: "/patient/notifications", label: "Notifications", short: "Alerts", icon: <BellIcon /> },
        { to: "/patient/uploads", label: "Uploads", short: "Upload", icon: <UploadIcon /> },
        { to: "/patient/family", label: "Family", short: "Family", icon: <UsersIcon /> },
        { to: "/patient/emergency-contacts", label: "Emergency", short: "SOS", icon: <SosIcon /> },
        { to: "/patient/addresses", label: "Addresses", short: "Address", icon: <PinIcon /> },
        { to: "/patient/support", label: "Support", short: "Help", icon: <LifebuoyIcon /> },
        { to: "/patient/settings", label: "Settings", short: "Settings", icon: <GearIcon /> },
        { to: "/patient/profile", label: "Profile", short: "Profile", icon: <UserIcon /> },
      ]}
    />
  );
}
